import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';


@Injectable({

  providedIn: 'root'

})

export class ProfileNavService {


  private navigationSubject = new Subject<string>();


  navigation$ = this.navigationSubject.asObservable();


  navigate(flow: string): void {

    this.navigationSubject.next(flow);

  }

}